var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyTextIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "copy-outline",
    transform: "translate(-47.5 -47.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_154447",
    "data-name": "Rectangle 154447",
    width: 9,
    height: 9,
    rx: 2,
    transform: "translate(51 51)",
    fill: "none",
    stroke: "rgb(232, 176, 62)",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16075",
    "data-name": "Path 16075",
    d: "M57.66,50.3l.014-.691A1.617,1.617,0,0,0,56.062,48H49.843A1.848,1.848,0,0,0,48,49.843v6.219a1.617,1.617,0,0,0,1.612,1.612H50.3",
    fill: "none",
    stroke: "rgb(232, 176, 62)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyTextIcon);
export default __webpack_public_path__ + "static/media/copy-text-icon.faa35a6db89cb3cd0a3c2aee5aa2a928.svg";
export { ForwardRef as ReactComponent };